export default () => ({
  listItem: {
    paddingLeft: 5,
    padding: 0,
  },
  tagTypeExpansionPanel: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
  },
  tagListContainer: {
    maxHeight: 250,
    overflow: 'auto',
    padding: 0,
  },
});
